"use client";

import * as React from "react";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area";
import { cn } from "@/lib/utils";
const rooms = ["Kitchen", "Bedroom", "Bathroom", "Living Room", "Home Office", "Pantry", "Entryway", "Kids Room", "Laundry", "Garage", "Outdoor", "Closet"];
export default function BrowseByRoom() {
  const [activeRoom, setActiveRoom] = useState("Kitchen");
  return <section id="browse-by-room" className="w-full bg-background py-12 md:py-16 border-b border-border/40">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-8 text-center md:text-left">
          <h2 className="font-serif text-3xl md:text-4xl font-medium text-foreground tracking-tight">
            Browse by Room
          </h2>
          <p className="mt-2 text-muted-foreground max-w-2xl">
            Explore organization tips and storage solutions tailored for every space in your home.
          </p>
        </div>

        <div className="relative w-full">
          <ScrollArea className="w-full whitespace-nowrap pb-4">
            <div className="flex w-max space-x-3 p-1">
              {rooms.map((room, i) => <Button key={room} data-index={i} variant="outline" onClick={() => setActiveRoom(room)} className={cn("rounded-full px-6 py-2 h-auto text-base font-medium transition-all duration-300 border", activeRoom === room ? "bg-chart-1 text-white border-chart-1 shadow-md hover:bg-chart-1/90 hover:text-white" : "bg-white text-muted-foreground border-border hover:border-chart-1 hover:text-chart-1 hover:bg-white")}>
                  {room}
                </Button>)}
            </div>
            <ScrollBar orientation="horizontal" className="invisible md:visible" />
          </ScrollArea>
        </div>
      </div>
    </section>;
}